import { ChangeDetectorRef, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs';
import { MoovExecutionStatusResponse } from '../../responses/moovExecutionStatusResponse';
import { AccountService } from '../../services/AccountService';

@Component({ standalone:false,
  selector: 'app-moov-execution-status-dialog',
  templateUrl: 'moov-execution-status-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['moov-execution-status-dialog.component.scss']
})
export class MoovExecutionStatusDialogComponent {
  title: string= "moov execution status";
  confirmButtonText = "";
  cancelButtonText = "Close";

  public moovExecutionStatusResponse!:MoovExecutionStatusResponse;
  public invokedByUser?:string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<MoovExecutionStatusDialogComponent>, private accService:AccountService, private cd:ChangeDetectorRef) {
    if(data){
      this.moovExecutionStatusResponse=data.moovExecutionStatusResponse;
      this.confirmButtonText = this.moovExecutionStatusResponse.executingMoovs?"Pause moov execution":"Restart moov execution";
    }
  }

  ngOnInit(){
    this.accService.getUserName(this.moovExecutionStatusResponse.invokedByUserId).pipe(take(1)).subscribe((userName:string|undefined)=>{
        this.invokedByUser=userName;
        this.cd.detectChanges();
      });
  }

  onConfirmClick(): void {
    this.dialogRef.close(!this.moovExecutionStatusResponse.executingMoovs);
  }
  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}